export default {
  account: {
    id: null,
    email: '',
    name: ''
  },
  station: {
    id: null,
    name: '',
    CurrentClienteNormal: 0,
    CurrentClientePreferencial: 0,
    filaPreferencial: 0,
    filaNormal: 0
  }
}
